import { useParams } from 'react-router-dom'

import { DatasetDetailsOperationBar, PageContainer } from '@/components'
import { config } from '@/config'

import { FinancesDetailsForm } from './components'
import { useFinancesDetails, useFinancesDetailsForm } from './hooks'

export const FinancesDetailsPage = () => {
  const { id } = useParams()
  const {
    datasetInfo,
    isFetching,
    allDatasetNames,
    getDownloadFileUrl,
    updateDataset,
    archiveDataset,
    unArchiveDataset,
    removeDataset,
    lockDataset,
    cloneDataset,
    isUpdateDatasetInProgress,
    isCloneDatasetInProgress
  } = useFinancesDetails(+(id || ''))

  const { isFormValid, isFormTouched, handleSubmitForm, formControl } =
    useFinancesDetailsForm(updateDataset, datasetInfo)

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[
            { title: 'Library' },
            { title: 'Finances', path: config.links.library.finances },
            { title: datasetInfo?.name || '' }
          ]}
        />
      }
      menuBar={
        !datasetInfo ? null : (
          <DatasetDetailsOperationBar
            datasetInfo={datasetInfo}
            onArchiveDataset={archiveDataset}
            onUnArchiveDataset={unArchiveDataset}
            onLockDataset={lockDataset}
            onRemoveDataset={removeDataset}
            onCloneDataset={(datasetName, onSuccess) =>
              cloneDataset(datasetName, { onSuccess })
            }
            isCloneDatasetInProgress={isCloneDatasetInProgress}
            allDatasetNames={allDatasetNames}
            isLockDisabled={!isFormValid || isFormTouched}
            saveButton={{
              onClick: handleSubmitForm,
              isDisabled: !isFormTouched || isUpdateDatasetInProgress,
              isLoading: isUpdateDatasetInProgress
            }}
          />
        )
      }>
      <FinancesDetailsForm
        datasetInfo={datasetInfo}
        formControl={formControl}
        isSubmitInProgress={isUpdateDatasetInProgress}
        getDownloadFileUrl={getDownloadFileUrl}
      />
    </PageContainer>
  )
}
